import { useEffect, useState } from "react";
import axios from "axios";

interface Estado {
  id: number;
  sigla: string;
  nome: string;
}

interface Cidade {
  nome: string;
}

interface EstadosECidades {
  [uf: string]: string[];
}

const fetchEstadosECidades = async (): Promise<EstadosECidades> => {
  try {
    const response = await axios.get<Estado[]>("https://servicodados.ibge.gov.br/api/v1/localidades/estados");
    const estados = response.data;
    const estadosECidades: EstadosECidades = {};
    
    for (const estado of estados) {
      const cidadesResponse = await axios.get<Cidade[]>(
        `https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estado.id}/municipios`
      );
      estadosECidades[estado.sigla] = cidadesResponse.data.map((cidade) => cidade.nome);
    }

    return estadosECidades;
  } catch (error) {
    console.error("Erro ao buscar estados e cidades:", error);
    return {};
  }
};

export default function useEstadosECidades() {
  const [estadosECidades, setEstadosECidades] = useState<EstadosECidades>({});

  useEffect(() => {
    fetchEstadosECidades().then(setEstadosECidades);
  }, []);

  return estadosECidades;
}